module.exports = __webpack_public_path__ + "img/cn-xj.e54d019e.svg";